import './App.css';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import Header from './component/common/Header';
import Footer from './component/common/Footer';
import PersonalInformationPage from "./component/PersonalInformationPage/PersonalInformationPage";
import ContactAddressPage from "./component/ContactAddressPage/ContactAddressPage";
import RegistrationPage from "./component/RegistrationPage/RegistrationPage";
import UploadPage from "./component/UploadPage/UploadPage";
import FinancialInformationPage from "./component/FinancialInformationPage/FinancialInformationPage";
import TaxResidencyPage from "./component/TaxResidencyPage/TaxResidencyPage";
import PoliticalExposurePage from "./component/PoliticalExposure/PoliticalExposurePage";
import DocumentationDeliveryPage from "./component/DocumentationDelivery/DocumentationDeliveryPage";
import MarketingConsentPage from "./component/MarketingConsentPage/MarketingConsentPage";
import { ZahtjevProvider } from "./common/context/ZahtjevProvider";
import React from "react";
import { QueryClientProvider } from "@tanstack/react-query";
import queryClient from "./config/queryClient";
import { NotificationProvider } from "./common/context/NotificationProvider";
import { DialogProvider } from "./common/context/DialogProvider";
import SummaryPage from "./component/SummaryPage/SummaryPage";
import { FinalPage } from "./component/FinalPage/FinalPage";
import { RedirectPage } from "./component/RedirectPage/RedirectPage";
import { ScrollToTop } from "./component/common/ScrollToTop";
import "./i18n";

function App() {

    return (
      <QueryClientProvider client={queryClient}>
          <BrowserRouter basename={process.env.REACT_APP_HOMEPAGE_BASENAME!}>
              <NotificationProvider>
                  <DialogProvider>
                      <ZahtjevProvider>
                          <div className="flex flex-col min-h-screen w-full overflow-x-hidden bg-gray-50">
                              <Header />
                              <main
                                className="relative z-10 transform -translate-y-16 md:-translate-y-20 w-full max-w-screen-xl mx-auto px-4 flex-grow">
                                  <ScrollToTop />
                                  <Routes>
                                      <Route path="/" element={<RegistrationPage />} />
                                      <Route path="/registration" element={<RegistrationPage />} />
                                      <Route path="/upload" element={<UploadPage />} />
                                      <Route path="/personal-information" element={<PersonalInformationPage />} />
                                      <Route path="/contact-address" element={<ContactAddressPage />} />
                                      <Route path="/financial-information" element={<FinancialInformationPage />} />
                                      <Route path="/tax-residency" element={<TaxResidencyPage />} />
                                      <Route path="/political-exposure" element={<PoliticalExposurePage />} />
                                      <Route path="/documentation-delivery" element={<DocumentationDeliveryPage />} />
                                      <Route path="/marketing-consent" element={<MarketingConsentPage />} />
                                      <Route path="/summary" element={<SummaryPage />} />
                                      <Route path="/completed" element={<FinalPage />} />
                                      <Route path="/redirect" element={<RedirectPage />} />
                                  </Routes>
                              </main>
                              <Footer />
                          </div>
                      </ZahtjevProvider>
                  </DialogProvider>
              </NotificationProvider>
          </BrowserRouter>
      </QueryClientProvider>
    );
}

export default App;
